@if (isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in"
    (click)="onBackdropClick()"
  >
    <div
      class="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden animate-scale-in"
      (click)="$event.stopPropagation()"
    >
      <!-- Content -->
      <div class="p-6 text-center">
        <!-- Icon -->
        <div
          class="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
          [ngClass]="getIconColorClass()"
        >
          <lucide-icon [img]="getIcon()" class="w-6 h-6"></lucide-icon>
        </div>

        <!-- Title -->
        <h3 class="text-lg font-bold text-gray-900 mb-2">
          {{ title() }}
        </h3>

        <!-- Message -->
        <p class="text-sm text-gray-500 mb-6">
          {{ message() }}
        </p>

        <!-- Actions -->
        <div class="flex gap-3">
          <button
            type="button"
            (click)="onCancel()"
            class="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium text-sm transition-colors cursor-pointer"
          >
            {{ cancelText() }}
          </button>
          <button
            type="button"
            (click)="onConfirm()"
            class="flex-1 px-4 py-2.5 rounded-xl font-medium text-sm transition-colors cursor-pointer"
            [ngClass]="getConfirmButtonClass()"
          >
            {{ confirmText() }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
